module.exports = __webpack_public_path__ + "static/media/div2.96d8a9ff.jpg";